import React, { useState, useRef } from 'react';
import { makeStyles, Paper, Popover } from '@material-ui/core';
import { classNameAndClasses } from '../../utils/objectString';

const useStyles = makeStyles((theme) => ({
  popover: {
    background: '#00000055',
    '& .MuiPopover-paper': {
      background: 'transparent',
      boxShadow: '0 0',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
  },
  paper: {
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.937rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    background: '#fff',
  },
}));
export default function CenterPopover(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(useRef());
  const { className, open, children } = props;

  return (
    <Popover
      {...props}
      className={classNameAndClasses(className, 'root', classes.popover)}
      open={open}
      ref={(el) => {
        setAnchorEl(el);
      }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <Paper id="paper123" className={classNameAndClasses(className, 'paper', classes.paper)}>
        {children}
      </Paper>
    </Popover>
  );
}
